import axios from "axios";
import uRLs from "../utils/baseUtils";
import { getData, setData,removeData } from "./CookieUtiles";

let isRefreshing = false;
let refreshSubscribers = []; 

const axiosInstance = axios.create({
  baseURL: uRLs.BASE_URL,
  headers: { "Content-Type": "application/json" },
});
const axiosInstance2 = axios.create({
   baseURL: uRLs.BASE_URL,
  headers: { "Content-Type": "multipart/form-data" },
});

const createToken = async (refreshToken) => {
  removeData("accessToken");
  if (!refreshToken) {
    return false;
  }
  try {    
    const response = await axios.get(`${uRLs.BASE_URL}ownerauth/create-token`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${refreshToken}`,
      },
    });

    if (response) {
      setData("accessToken", response.data.results.accessToken);
      // window.location.reload();
      return response.data.results.accessToken;
    }

    throw new Error("Invalid response from create-token API");
  } catch (error) {
    throw error;
  }
};

const setupInterceptors = (instance) => {
  instance.interceptors.request.use((config) => {
    const token = getData("AccessToken");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        if (!isRefreshing) {
          isRefreshing = true;
       
          const refreshToken = getData("RefreshToken"); 
          if (!refreshToken) {          
            removeData("AccessToken");
            removeData("RefreshToken");
            window.location.href = "/login";
            return Promise.reject(error);
          }

          try {
            const newToken = await createToken(refreshToken);
            if (newToken) {
              setData("AccessToken", newToken);
              isRefreshing = false;
              refreshSubscribers.forEach((callback) => callback(newToken));
              refreshSubscribers = [];

              originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
              return instance(originalRequest);
            }
          } catch (err) {
            isRefreshing = false;
            removeData("AccessToken");
            removeData("RefreshToken");
            window.location.href = "/login";
            return Promise.reject(err);
          }
        }
        return new Promise((resolve) => {
          refreshSubscribers.push((newToken) => {
            originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
            resolve(instance(originalRequest));
          });
        });
      }
      return Promise.reject(error);
    }
  );
};

setupInterceptors(axiosInstance);
setupInterceptors(axiosInstance2);

export const apiRequest = async (method, url, data = {}, instance = axiosInstance) => {
  try {
    const response = await instance({
      method,
      url,
      data,
      params: method === "GET" ? data : undefined,
    });
    return response.data;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export { axiosInstance ,axiosInstance2 }; 
export default axiosInstance;